import { useState } from "react";
import { ApiError } from "../../common/api/ApiClient";
import { useApiClient } from "../../common/hooks/useApiClient";
import {
  NationBuilderTags,
  Person,
} from "../../common/models/schema/UpdatePersonResponse";
import { ResearchTaskStatus } from "../../common/models/schema/ResearchTask";
import { useResearchTasks } from "../../common/contexts/ResearchTaskProvider";
const apiPath = "/nationbuilder/research-person";

export const useUpdate360 = () => {
  const [personId, setPersonId] = useState("");
  const [person, setPerson] = useState<Person | null>(null);
  const [tags, setTags] = useState<NationBuilderTags[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [agree360, setAgree360] = useState(false);
  const [enoughDataAgreement, setEnoughDataAgreement] = useState(false);
  const [autoInviteToCircle, setAutoInviteToCircle] = useState(false);
  const apiClient = useApiClient();
  const { setTask } = useResearchTasks();

  const handleSubmit = async () => {
    if (!personId.trim()) return;

    setLoading(true);
    setError(null);

    try {
      await apiClient.put<any>(apiPath, {
        person_id: Number(personId),
        auto_invite_to_circle: autoInviteToCircle,
      });
      setTask({
        id: personId,
        task_status: ResearchTaskStatus.RUNNING,
        task_result: null,
        created_at: new Date(),
        updated_at: new Date(),
        error: null,
      });
      setPersonId("");
      setLoading(false);
    } catch (err) {
      const apiError = err as ApiError;
      setError(apiError.data?.detail || apiError.message);
    }
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setError(null);
    setPerson(null);
    setTags([]);

    // Only allow numbers
    if (/^\d*$/.test(value)) {
      setPersonId(value);
    }
  };

  const resetForm = () => {
    setPersonId("");
    setPerson(null);
    setTags([]);
    setError(null);
  };

  return {
    // State
    personId,
    person,
    tags,
    loading,
    error,
    agree360,
    enoughDataAgreement,
    autoInviteToCircle,
    // Actions
    handleSubmit,
    handleInputChange,
    resetForm,
    setAgree360,
    setEnoughDataAgreement,
    setAutoInviteToCircle,
  };
};
